import React from 'react';
import { ColumnComponentProps } from 'v2/utils/searchViewUtils';

const Reviewer = ({ search }: ColumnComponentProps) => {
  return (
    <p className="d-flex align-items-center">
      {search.assigned_to?.first_name} {search.assigned_to?.last_name}
    </p>
  );
};

export default Reviewer;
